import React from 'react';
interface PlaceholderFieldProps {
  label: string;
  className?: string;
}

/**
 * Non-interactive outline standing in for a field rendered by a native frame.
 * Deliberately NOT an <input>: real field names/IDs come from the native output.
 */
export function PlaceholderField({
  label,
  className = ''
}: PlaceholderFieldProps) {
  return <div className={className} aria-hidden="true" data-id="element-540" data-mp="26qkwwija8jjm">
      <span className="block text-[13px] text-ink-muted" data-id="element-541" data-mp="33fk55xjv9lbt">{label}</span>
      <span className="mt-1.5 block h-12 rounded-[3px] border border-line bg-surface" data-id="element-542" data-mp="33gvcg7citb7o" />
    </div>;
}